// Data source types
export type DataSourceType = 'matchControl';
export enum DataSourceNames {
  matchControl = 'Match Control',
}

// Base categories for suggestions
export type BaseSuggestionCategory =
  | 'Teams'
  | 'Members'
  | 'Score'
  | 'Users'
  | 'Players'
  | 'Contestants';

// Domain-specific shortcut categories (only these are actually used)
export type DomainShortcutCategory =
  | `Age - ${BaseSuggestionCategory}`
  | `Name - ${BaseSuggestionCategory}`
  | `Caps - ${BaseSuggestionCategory}`
  | `Matches - ${BaseSuggestionCategory}`
  | `Goals - ${BaseSuggestionCategory}`;

// All possible suggestion categories (simplified)
export type SuggestionCategory = BaseSuggestionCategory | DomainShortcutCategory;

// Domain-specific shortcut configuration
export interface DomainShortcut {
  prefix: string;
  description: string;
  template: string;
  applicableCategories: BaseSuggestionCategory[];
  categoryPrefix: string;
}

// Suggestion option for autocomplete
export interface SuggestionOption {
  value: string;
  label: string;
  category: SuggestionCategory;
  source: DataSourceType;
  data: unknown;
  searchableText: string;
}

// Data source adapter interface
export interface DataSourceAdapter<T = unknown> {
  readonly type: DataSourceType;
  process(data: T): SuggestionOption[];
  isAvailable(state: unknown): boolean;
  extractData(state: unknown): T | null;
  // Handle special character queries directly in the data source
  processSpecialCharacterQuery?(query: string, data: T): SuggestionOption[];
}

// Grouped options for display
export interface GroupedSuggestion {
  label: string;
  options: SuggestionOption[];
}
